import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ProductCell from './ProductCell'
import { axios } from 'api'
import styled from 'styled-components'
import { useCommonEntryContext } from 'components_v2/common'

const Main = styled.div`
  .product-difficulty svg {
    max-width: 13px;
  }
`
const titleize = (str) =>
  str
    .split(/[\s_-]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')

const TagsView = () => {
  const { id } = useParams()
  const [plans, setPlans] = useState([])
  const { setNotFound } = useCommonEntryContext()
  useEffect(() => {
    axios
      .get(`/plans/tag/${id}`, { load: true })
      .then((res) => {
        setPlans(res.data || [])
        setNotFound(!Boolean(res.data?.length > 0))
      })
      .catch((err) => console.log(err))
  }, [id, setNotFound])

  const displayTitle = id === id.toLowerCase() ? titleize(id) : id
  const refmarksPrefix = id.toLowerCase()

  if (!(plans?.length > 0)) return null
  return (
    <Main>
      <div className='container explore-container' style={{ width: '100%' }}>
        <div className='fullwidth'>
          <div className='grey-cover-header'>
            <div className='grey-centered-content'>
              <div
                id='index-title-block'
                className='container-16 container-featured'
                data-refmarks-prefix={`${refmarksPrefix}_rl`}
              >
                <h1>Tagged in '{displayTitle}'</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='tag-product-container'
        data-refmarks-prefix={refmarksPrefix}
      >
        <div className='products-grid'>
          {plans.map((plan) => (
            <div className='product' key={plan.id}>
              <ProductCell product={plan} />
            </div>
          ))}
        </div>
      </div>
    </Main>
  )
}

export default TagsView
